module.exports = __webpack_public_path__ + "img/redBg.656b3f36.svg";